import React from "react";
import { PageHero, CtaBanner } from "@/components/PageParts";

export default function OurStory() {
  return (
    <div data-testid="page-our-story">
      <PageHero
        eyebrow="Our Story"
        title="A filmmaker, a family, and the years that shaped this craft."
        subtitle="Family Legacy Films began with a single film for the founder's grandfather — and a promise to make sure other families didn't wait too long."
        image="https://customer-assets-m6fa6gv7.emergentagent.net/job_legacy-stories-hub/artifacts/b45tvwsn_grandparents-playing-with-granddaughter-at-home-2025-04-04-13-07-09-utc.webp"
        testid="our-story-hero"
      />

      <section className="section-pad bg-offwhite">
        <div className="max-w-4xl mx-auto px-6 md:px-10 space-y-8 text-lg text-warmgrey leading-relaxed">
          <p className="eyebrow">The Beginning</p>
          <p>
            I made my first legacy film for my grandfather. He was 80 and losing his memory. On one visit overseas
            to the family home, I recorded him on my mobile phone — and he talked about it all: the years he spent
            in the army, his marriage, his first child, his hobbies (cars, above everything), and his first
            grandchild, which was me. He was always the one taking the videos and the photos of me — and now, at
            last, I was recording his story.
          </p>
          <p>
            When he passed, that simple phone video became the most important thing our family owns. My children,
            who never met him, still know his voice, his laugh, the way he said their names. It's the film I wish
            every family had.
          </p>
          <p className="eyebrow pt-6">The Promise</p>
          <p>
            Family Legacy Films exists so that other families do not wait too long. We work across Sydney and
            Canberra with elders and their families, and we work with grieving families needing dignified funeral
            videography. Every film is treated with care, patience and unhurried craft.
          </p>
        </div>
      </section>

      <section className="bg-secondary text-white py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="font-serif text-3xl md:text-4xl italic leading-relaxed" style={{ color: "#F2E8D3" }}>
            "The best time to record your parents' story was twenty years ago.
            <span style={{ color: "#C9A961" }}> The second best time is now.</span>"
          </p>
        </div>
      </section>

      <CtaBanner title="Meet with us." subtitle="A free, unhurried 20-minute call — no pressure, no obligation." testid="our-story-cta" />
    </div>
  );
}
